import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ContactUsPage } from "~/pages/ContactUs";

export const Route = createFileRoute("/contact-us")({
  head: () => ({ meta: [{ title: i18n.t("general:contactUs") }] }),
  component: ContactUsPage,
});
